class FormAccordion {
	constructor(blockEl) {
		this.accordion = blockEl;
		this.triggers = [...this.accordion.querySelectorAll('.js__accordion-trigger')];
		if (!this.triggers.length) return;
		this.setHandlers();
		this.openFirst();
	}

	setHandlers() {
		this.triggers.forEach(trigger => {
			const content = trigger.nextElementSibling;

			trigger.addEventListener('click', () => {
				const isActive = trigger.classList.contains('active');

				
				this.triggers.forEach(t => {
					t.classList.remove('active');
					const c = t.nextElementSibling;
					if (c) {
						c.style.maxHeight = null;
						c.style.opacity = 0;
						c.style.visibility = 'hidden';
					}
				});
                
				if (!isActive) {
					trigger.classList.add('active');
					if (content) {
						content.style.maxHeight = content.scrollHeight + 'px';
						content.style.opacity = 1;
						content.style.visibility = 'visible';
					}
				}
			});
		});
	}

	openFirst() {
		const firstTrigger = this.triggers[0];
		if (!firstTrigger) return;
		const firstContent = firstTrigger.nextElementSibling;

		firstTrigger.classList.add('active');
		if (firstContent) {
			firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
			firstContent.style.opacity = 1;
			firstContent.style.visibility = 'visible';
		}
	}
}

export default FormAccordion;


